import _ from 'lodash';
import { receiveOutline } from '../containers/builder/actions';

export const isValid = (config) => !!(config && config.type);

export const loadConfigRoute = async ({ store, res }) => {
  // Only run bootstrap on the server
  if (!res) {
    return;
  }

  // The route config gets set on the server, from a wordpress request
  // see `server/config-fetcher.js`
  const config = _.get(res, 'locals.routeConfig');

  if (config) {
    // Got a config!
    // Send to store
    store.dispatch(receiveOutline(config));
  }
};
